import { WorkflowStatusKinds } from "../kinds";

// WF状態名
export class WorkflowStatusName {
  constructor(
    public code: number,
    public name: string,
    public waitName: string,
    public doneName: string,
    public type: WorkflowStatusKinds,
  ) { }

  clone(): WorkflowStatusName {
    return new WorkflowStatusName(
      this.code,
      this.name,
      this.waitName,
      this.doneName,
      this.type);
  }

  static areEqual(source: WorkflowStatusName, dest: WorkflowStatusName): boolean {
    return (source === dest)
     || (source && dest && (source.code === dest.code));
  }
}
